import React, {Component} from 'react';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';
import Paper from '@material-ui/core/Paper';
import {makeStyles} from '@material-ui/core/styles';
import axios from "axios";
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import InputAdornment from "@material-ui/core/InputAdornment";
import AirplanemodeInactiveIcon from '@material-ui/icons/AirplanemodeInactive';
import SettingsBackupRestoreIcon from '@material-ui/icons/SettingsBackupRestore';
import Checkbox from "@material-ui/core/Checkbox";
import ListItemText from "@material-ui/core/ListItemText";
import FormHelperText from "@material-ui/core/FormHelperText";
import CollapsibleAreaCoverageAdvancedOptions from "./CollapsibleAreaCoverageAdvancedOptions";
import Sidebar from "../SideBar";
import {gsd, computeScanningDensity} from "../../utils/utils";



class CalculateAreaCoveragePathsForm extends Component {

    render() {
        const {
            project,
            onProjectChange,
            darpLoading,
            onNumberOfDronesChange,
            onResetRegionOfInterest,
            onExecuteCalculatePathsClick,
            onExecuteTreeadsPathsClick,
            onCancelDarpClick,
            onAddNoFlyZoneClick,
            numberOfDronesChangeLoading
        } = this.props;

        return (
            <div>

                    {/*<div style={{padding: '10px', margin: '5px'}}>*/}
                    {/*    <FormControl style={{width: '200px'}}>*/}
                    {/*        <InputLabel htmlFor="type-of-mission">Mission</InputLabel>*/}
                    {/*        <Select*/}
                    {/*            value={project.mission}*/}
                    {/*            onChange={(evt) => {*/}
                    {/*                onProjectChange('mission', evt);*/}
                    {/*                onResetOperationalArea();*/}
                    {/*            }}*/}
                    {/*            inputProps={{*/}
                    {/*                name: 'Type of Mission',*/}
                    {/*                id: 'type-of-mission',*/}
                    {/*            }}*/}
                    {/*        >*/}
                    {/*            <MenuItem value={'follow-path'}>Follow Path</MenuItem>*/}
                    {/*            <MenuItem value={'coverage'}>Coverage</MenuItem>*/}
                    {/*            <MenuItem value={'real-time-tracking'} disabled>Real-time tracking</MenuItem>*/}
                    {/*        </Select>*/}
                    {/*    </FormControl>*/}
                    {/*</div>*/}
                    <Paper style={{marginTop: '10px',
                        marginBottom: '10px'}}>
                        <TextField style={{textAlign: "left"}}
                                   id="project-name"
                                   label="Project Name"
                                   value={project.name}
                                   onChange={(evt) => {
                                       onProjectChange('name', evt)
                                   }}
                                   margin="normal"
                                   disabled={darpLoading}
                        />
                    </Paper>

                <Paper style={{

                    marginTop: '10px',
                    marginBottom: '10px'
                }}>
                    <span>Operational Area</span>
                    <div style={{display: 'flex',
                    justifyContent: 'space-between'}}>
                    <Button variant="outlined" style={{margin: '5px'}} onClick={onAddNoFlyZoneClick} disabled={darpLoading} >
                        <AirplanemodeInactiveIcon/>
                        Add No-fly zone
                    </Button>
                    <Button variant="outlined" style={{margin: '5px', whiteSpace: 'noWrap'}}
                            onClick={onResetRegionOfInterest(project.type)} disabled={darpLoading}>
                        <SettingsBackupRestoreIcon/>Reset ROI</Button>
                    </div>
                    <div style={{padding: '5px'}}>
                        <div>Area: {parseInt(project.areaOfInterestArea).toLocaleString('gr')} m&#178;</div>
                    </div>

                </Paper>


                    {/*{(project.mission === 'coverage') ? (*/}

                    {/*) : null}*/}




                {/*{(project.mission === 'coverage') ? (*/}
                <Paper style={{marginTop: '10px'}}>


                    <div style={{position: 'relative', display: 'inline-block'}}>
                        <TextField style={{width: '200px'}}
                                   id="standard-number"
                                   label="Drones"
                                   value={project.numberOfDrones}
                                   inputProps={{
                                       onKeyDown: (event) => {
                                           event.preventDefault();
                                       },
                                       style: {
                                           caretColor: 'transparent', // Hide the cursor
                                           userSelect: 'none', // Prevent text selection
                                       },
                                   }}
                                   // disabled={true}
                                   onChange={(evt) => onNumberOfDronesChange(evt.target.value)}
                                   type="number"
                                   margin="normal"
                                   disabled={numberOfDronesChangeLoading || darpLoading}
                        />
                        {numberOfDronesChangeLoading && (
                            <CircularProgress
                                size={24}
                                style={{
                                    position: 'absolute',
                                    top: '50%',
                                    right: '-40px',
                                    marginTop: '-12px',
                                }}
                            />
                        )}
                    </div>

                    <div>
                        <TextField style={{width: '200px'}}
                                   id="standard-name"
                                   label="Altitude"
                                   value={project.altitude}
                                   onChange={(evt) => onProjectChange('altitude', evt)}
                                   InputProps={{
                                       endAdornment: <InputAdornment position="end">m</InputAdornment>,
                                   }}
                                   margin="normal"
                                   disabled={darpLoading}
                        />
                    </div>


                    <div>
                        <TextField style={{width: '200px'}}
                                   id="standard-percentageOfSidelap"
                                   label="Sidelap"
                                   type="number"
                                   value={project.percentageOfSidelap}
                                   onChange={(evt) => {

                                       if(!evt.target.value) {
                                           evt.target.value = 0;
                                       }
                                       let percentageOfSidelap = parseInt(evt.target.value, 10)
                                       if(percentageOfSidelap < 0) evt.target.value = 0;
                                       else if(percentageOfSidelap > 99) evt.target.value = 99;
                                       else evt.target.value = percentageOfSidelap;
                                       onProjectChange('percentageOfSidelap', evt)
                                   }}
                                   InputProps={{
                                       inputProps: {min:0, max:99,},
                                       endAdornment: <InputAdornment position="end">%</InputAdornment>,
                                   }}
                                   margin="normal"
                                   disabled={darpLoading}
                        />
                    </div>

                    <div style={{padding: '5px'}}>
                        <div>Scanning density: {computeScanningDensity(project.altitude, project.percentageOfSidelap).toFixed(2)} m</div>
                    </div>
                    <div style={{padding: '5px'}}>
                        <div>GSD: {gsd(project.altitude).toFixed(2)} cm/px</div>
                    </div>

                </Paper>
                <Paper style={{marginTop: '10px'}}>
                    <CollapsibleAreaCoverageAdvancedOptions project={project}
                                                            onPortionsChange={this.props.onPortionsChange}
                                                            onProjectCheckboxChange={this.props.onProjectCheckboxChange}/>

                    <div style={{position: 'relative', padding: '5px'}}>
                        <Button style={darpLoading ? {width: '100px'} : {width: '220px'}} variant="outlined"
                                disabled={darpLoading} onClick={onExecuteCalculatePathsClick}>{
                            darpLoading ? 'Loading...' : 'Calculate Paths'}</Button>
                        {darpLoading && <CircularProgress size={24} style={{
                            // color: 'green[500]',
                            position: 'absolute',
                            top: '50%',
                            left: '25%',
                            marginTop: -12,
                            // marginLeft: -12,
                        }}/>}
                        {darpLoading ? <Button style={{width: '100px'}} variant="outlined"
                                               onClick={onCancelDarpClick}>Cancel</Button> : null}
                    </div>
                    <div style={{position: 'relative', padding: '5px'}}>
                        <Button style={darpLoading ? {width: '100px'} : {width: '220px'}} variant="outlined"
                                disabled={darpLoading} onClick={onExecuteTreeadsPathsClick}>{
                            darpLoading ? 'Loading...' : 'Treeads'}</Button>
                        {darpLoading && <CircularProgress size={24} style={{
                            // color: 'green[500]',
                            position: 'absolute',
                            top: '50%',
                            left: '25%',
                            marginTop: -12,
                            // marginLeft: -12,
                        }}/>}
                    </div>

                </Paper>
            </div>
        )
    }
}

export default CalculateAreaCoveragePathsForm;
